// 🔧 user_step.js
// ✅ Purpose: User Builder pipeline step
// ✅ Features:
// - Executes the User Builder
// - Creates standardized pipeline results
// - Updates DemoContext
// - Fully block-commented for clarity and future devs

import { createPipelineStepSuccess } from "../pipeline_step";
import { buildUserShell } from "../../builders/user_builder";

export const createUserStep = () => ({
  name: "user_builder",

  label: "User Builder",

  run: async (context) => {
    const result = await buildUserShell(context);

    return createPipelineStepSuccess({
      step: "user_builder",
      label: "User Builder",

      created:
        result?.createdCount ||
        result?.plannedCount ||
        0,

      message: result?.message,

      metadata: result,

      startedAt: context.startedAt,
    });
  },

  afterSuccess: ({ result, sharedContext }) => {
    sharedContext.userResult =
      result?.metadata || null;

    sharedContext.users =
      result?.metadata?.createdUsers || [];
  },
});